import React from 'react';
import { Col, Divider, Row } from 'antd';
import { isEqual } from 'lodash';

import {
  MemberHistoryDetailsModel,
  ProfileCorporateBillingInfoModel,
} from 'api/adminApiClient';
import HistoryLog from '../../HistoryLog';
import HistoryField from '../../HistoryField';

import styles from '../../HistoryCard.module.less';

type Props = {
  historyDetails: MemberHistoryDetailsModel;
  historyId: string;
};

export default function BillingInformationDetailsCard(props: Props) {
  const { historyDetails, historyId } = props;
  const { oldData, newData } = historyDetails;
  const hasFirstNameChanged = !isEqual(
    oldData?.corporateInfo?.billingInfo?.firstName || '',
    newData?.corporateInfo?.billingInfo?.firstName || '',
  );
  const hasLastNameChanged = !isEqual(
    oldData?.corporateInfo?.billingInfo?.lastName || '',
    newData?.corporateInfo?.billingInfo?.lastName || '',
  );

  const hasEmailChanged = !isEqual(
    oldData?.corporateInfo?.billingInfo?.email || '',
    newData?.corporateInfo?.billingInfo?.email || '',
  );

  const hasPhoneNumberChanged = !isEqual(
    oldData?.corporateInfo?.billingInfo?.phoneNumber || '',
    newData?.corporateInfo?.billingInfo?.phoneNumber || '',
  );

  const renderBillingInfo = (
    billingInfo?: ProfileCorporateBillingInfoModel,
  ) => {
    const sectionName = 'billing-information';

    return (
      <>
        <Row gutter={[10, 10]}>
          <Col xs={24}>
            <div className={styles.cardTitle}>Billing information</div>
          </Col>

          {hasFirstNameChanged && (
            <HistoryField
              title="A/P first name"
              value={billingInfo?.firstName}
              dataId={`${sectionName}-first-name-field`}
            />
          )}

          {hasLastNameChanged && (
            <HistoryField
              title="A/P last name"
              value={billingInfo?.lastName}
              dataId={`${sectionName}-last-name-field`}
            />
          )}

          {hasEmailChanged && (
            <HistoryField
              title="A/P email"
              value={billingInfo?.email}
              dataId={`${sectionName}-email-field`}
            />
          )}

          {hasPhoneNumberChanged && (
            <HistoryField
              title="A/P phone number"
              value={billingInfo?.phoneNumber}
              dataId={`${sectionName}-phone-number-field`}
            />
          )}
        </Row>

        <Divider />
      </>
    );
  };

  return (
    <HistoryLog
      historyId={historyId}
      oldData={renderBillingInfo(oldData?.corporateInfo?.billingInfo)}
      newData={renderBillingInfo(newData?.corporateInfo?.billingInfo)}
    />
  );
}
